<template>
  <div class="bankcard-card" >
    <div
      @click="click"
      class="card-info"
      :style="{
        background: `linear-gradient(
            90deg,
            ${
          bankTheme[data.bankCode]
            ? bankTheme[data.bankCode][0]
            : bankTheme.DEFAULT[0]
        } 0%,
            ${
          bankTheme[data.bankCode]
            ? bankTheme[data.bankCode][1]
            : bankTheme.DEFAULT[1]
        } 100%
        )`,
      }"
      :class="[
        {
          selected: showSwitch && data.default,
          unselected: showSwitch && !data.default,
          selectable: showSwitch,
        },
      ]"
    >
      <img
        class="custom-icon bank-icon"
        :src="loadBankIcon(data.bankCode)"
      />
      <div class="flex">
        <div class="bank-name">{{ data.bankName }}</div>
        <div class="bankcard-no">
          {{ data.bankCardNo | cardNoFilter }}
        </div>
      </div>
    </div>

    <!-- 是否设置为默认卡 -->
    <div class="switch" v-if="showSwitch">
      <div class="switch-button" :class="{ open: data.default }" @click.stop="toggle(data.default)">
        <div
          class="indicator"
          :class="{ open: data.default }"
        ></div>
      </div>
      <span  @click.stop="toggle(data.default)">代扣银行卡</span>
    </div>

    <nd-dialog
      v-model="showConfirmDialog"
      :close-btn="true"
      @close.stop="showConfirmDialog = false"
      :footer="false"
    >
      <div class="confirm-dialog">
        <div class="header">
          代扣银行卡
        </div>
        <div class="body">
          确认将该银行卡设置为代扣银行卡吗？
        </div>
        <nd-button class="footer" @click="confirm">
          确认
        </nd-button>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import bankTheme from './bank-theme'

export default {
  name: 'bankcard-card',
  data () {
    return {
      position: this.$route.query.position, // 埋点需要，判断来源
      showConfirmDialog: false,
      bankTheme: bankTheme
    }
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return {
          bankCode: '',
          bankName: '',
          bankCardNo: '',
          bankMobile: '',
          canChangePhoneNo: false,
          invalid: false,
          default: false
        }
      }
    },
    showSwitch: {
      type: Boolean,
      default: true
    }
  },

  filters: {
    cardNoFilter (val) {
      let str = '************' + String(val).substr(-4)
      return str.replace(/(.{4})/g, '$1 ')
    }
  },

  computed: {
    ...mapState('bankcard', {
      selectedBankcard: (state) => state.selectedBankcard || {}
    })
  },

  methods: {
    ...mapActions('bankcard', ['setDefaultBankCardX']),
    click () {
      // if (this.showSwitch) return 
      // if (this.data.invalid) {
      //     return this.reBind()
      // }
      this.$emit('click')
    },
    // 切换代扣卡开关
    toggle (bool) {
      if (bool) this.$message('通过设置其他代扣卡关闭本卡代扣设置')
      else this.showConfirmDialog = true
    },
    loadBankIcon (bankCode) {
      try {
        return require(`../../images/${bankCode.toLowerCase()}.jpg`)
      } catch (e) {}
    },
    async confirm () {
      if (this.data.invalid) {
        return this.reBind()
      }
      this.showConfirmDialog = false
      const res = await this.setDefaultBankCardX({
        loanPlatform: this.$route.query.loanPlatform,
        bankCardNo: this.data.bankCardNo,
        fundCode: this.$route.query.fundCode,
        billNo: this.$route.query.orderId
      })
      if (res.success) {
        this.showConfirmDialog = false
      } else {
        this.reBind()
      }
      this.$emit('change')
    },
    // 重新绑卡
    reBind () {
      this.$router.push({
        path: '/bankcard/add',
        query: {
          position: this.position,
          bankcardNo: this.data.bankCardNo,
          bankMobile: this.data.bankMobile,
          loanPlatform: this.$route.query.loanPlatform,
          fundCode: this.$route.query.fundCode,
          termId: this.$route.query.termId,
          orderId: this.$route.query.orderId,
          canChangePhoneNo: this.data.canChangePhoneNo
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.bankcard-card {
    width: 670px;
    overflow: hidden;
    .card-info {
        display: flex;
        align-items: flex-start;
        overflow: hidden;
        height: 210px;
        border-radius: 30px;
        color: #fff;
        padding: 40px;

        &.selectable {
            border-radius: 30px 30px 0 0;
        }
        &.unselected {
            background: linear-gradient(
                90deg,
                rgba(211, 211, 211, 1) 0%,
                rgba(226, 226, 225, 1) 100%
            ) !important;
        }
        &.disabled {
            background: linear-gradient(
                90deg, #D3D3D3 0%, #E2E2E1 100%
            ) !important;
        }

        .custom-icon {
            height: 50px;
            width: 50px;
            border-radius: 50%;
            margin-right: 18px;
        }
        .flex {
            flex: 1;
            .bank-name {
                font-size: 32px;
                font-weight: 400;
                line-height: 50px;
            }
            .bankcard-no {
                margin-top: 10px;
                font-size: 50px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                line-height: 60px;
            }
        }
    }

    .switch {
        display: flex;
        align-items: center;
        width: 670px;
        height: 90px;
        padding: 0 40px;
        font-size: 26px;
        font-weight: 400;
        border-radius: 0px 0px 30px 30px;
        border: 1px solid rgba(235, 235, 235, 1);

        .switch-button {
            display: flex;
            align-items: center;
            width: 80px;
            height: 40px;
            border-radius: 20px;
            margin-right: 24px;
            background-color: #dfdfdf;

            &.open {
                background-color: #78cc79;
            }

            .indicator {
                width: 38px;
                height: 38px;
                border-radius: 50%;
                background-color: #fff;
                transition: all 0.2s;
                &.open {
                    transform: translateX(42px);
                }
            }
        }
    }

    .confirm-dialog {
        padding: 20px 50px 40px;
        .header {
            font-size: 42px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 60px;
        }
        .body {
            margin-top: 24px;
            font-size: 30px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 42px;
        }
        .footer {
            width: 320px;
            height: 80px;
            line-height: 80px;
            margin: 120px auto 0;
        }
    }
}
</style>
